import React from 'react'
import axios from '~/data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import ButtonSimple from '~/Common-Objects/UI/Forms/ButtonSimple/ButtonSimple'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import UpsellModal from '~/Common-Objects/UpsellModal'
import { connect } from 'react-redux'
import * as siteMaster from '~/data/actions/siteActions'
import PermissionChecker from '~/Classes/permissions'
import TierPermissions from '~/Classes/tierPermissions'
import i18n from '~/i18n'
import queryString from 'query-string'
import {
    isVisibleCatalogApp,
    isVisibleInstalledApp,
    displayMailchimpAppName,
    isSharedMailchimpApp,
    usesNewMailchimpConnection
} from '~/utils/mailchimpImportBeta'
import { MAILCHIMP_FLOW_PATH } from '~/pages/cp/import/paths'
import { openMailchimpFlow } from '~/pages/cp/import/mailchimpFlowOrigin'
import AddApp from './addApp/'

@connect((store) => {
    return {
        user: store.user,
        permissionStore: store.permission,
        accountMaster: store.accountMaster,
        siteMaster: store.siteMaster
    }
})
export default class CompanyIntegrations extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: 1,
            apps: [],
            catalog: [],
            category: 'All',
            search: '',
            socialAccountsRequiredTier: null
        }

        this.getApplications = this.getApplications.bind(this)
        this.goConfig = this.goConfig.bind(this)
        this.view = this.view.bind(this)
        this.handleAvailableClick = this.handleAvailableClick.bind(this)
        this.showSocialAccountsUpsell = this.showSocialAccountsUpsell.bind(this)
    }

    componentDidMount() {
        this.getApplications(true)
        axios.get('/accountMaster/plan/requiredTier?feature=socialAccounts').then((res) => {
            this.setState({ socialAccountsRequiredTier: res.data })
        })
    }

    getApplications(firstRun) {
        Promise.all([axios.get('/accountMaster/application'), axios.get('/application')]).then(
            ([installedRes, catalogRes]) => {
                this.setState(
                    {
                        loading: 0,
                        apps: (installedRes.data.Applications || []).filter((app) => isVisibleInstalledApp(app)),
                        catalog: (catalogRes.data.Applications || [])
                            .filter((app) => isVisibleCatalogApp(app))
                            .sort((a, b) => {
                                if (a.featured && !b.featured) return -1
                                if (!a.featured && b.featured) return 1
                                return (a.appName || '').localeCompare(b.appName || '', undefined, {
                                    sensitivity: 'base'
                                })
                            })
                    },
                    () => {
                        if (firstRun == true) {
                            var query = queryString.parse(this.props.location.search)
                            if (query.show && parseInt(query.show)) {
                                this.view(undefined, parseInt(query.show))
                            }
                        }
                    }
                )
            }
        )
    }

    goConfig(app) {
        if (isSharedMailchimpApp(app.Application) && usesNewMailchimpConnection(app)) {
            openMailchimpFlow(this.props.history, MAILCHIMP_FLOW_PATH)
            return
        }
        if (app.Application.appConfigUri) {
            let appConfigUri = app.Application.appConfigUri
            if (appConfigUri.indexOf('[APPID]')) appConfigUri = appConfigUri.replace('[APPID]', app.Application.id)
            if (appConfigUri.indexOf('http') === 0) {
                window.open(appConfigUri, '_self')
            } else {
                this.props.history.push(appConfigUri + '?id=' + app.id)
            }
        } else {
            this.props.history.push('/cp/company/integrations/apps/integrationnoconfig/' + app.Application.id)
        }
    }

    handleAvailableClick(app) {
        const { isInstalled, allowMultiple, instances } = catalogInstallState(app, this.state.apps)
        const canAddDupes = TierPermissions('socialAccounts', this.props.accountMaster).allowed

        if (isInstalled && !allowMultiple) {
            this.goConfig(instances[0])
            return
        }
        if (isInstalled && allowMultiple && !canAddDupes) {
            this.showSocialAccountsUpsell()
            return
        }
        this.view(undefined, app.id)
    }

    showSocialAccountsUpsell() {
        const show = (requiredTier) => {
            if (!requiredTier) return
            const modal = (
                <UpsellModal
                    feature='socialAccounts'
                    requiredTier={requiredTier}
                    onUpgrade={() => {
                        this.props.dispatch(siteMaster.alterFullpage(null))
                    }}
                />
            )
            this.props.dispatch(siteMaster.alterFullpage(modal))
        }
        const cached = this.state.socialAccountsRequiredTier && this.state.socialAccountsRequiredTier.name
        if (cached) return show(cached)
        axios.get('/accountMaster/plan/requiredTier?feature=socialAccounts').then((res) => {
            this.setState({ socialAccountsRequiredTier: res.data })
            show(res.data && res.data.name)
        })
    }

    view(row, appId) {
        var drawer = (
            <AddApp
                appId={appId}
                history={this.props.history}
                browse={(url) => {
                    this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'right', null, false))
                    if (url.indexOf('http') === 0) {
                        window.open(url, '_self')
                    } else {
                        this.props.history.push(url)
                    }
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawer, false, '100vw', 'full'))
    }

    render() {
        if (this.state.loading) return <LoadingIcons />

        const canWrite = PermissionChecker('company', this.props.permissionStore.permissions, 'write')
        const canAddDupes = TierPermissions('socialAccounts', this.props.accountMaster).allowed
        const allLabel = i18n.t('company:integrations.main.allTypes')
        let types = [allLabel]
        this.state.catalog.forEach((service) => {
            if (service.category && types.indexOf(service.category) === -1) types.push(service.category)
        })
        if (types.includes('Other')) {
            types = types.filter((t) => t !== 'Other')
            types.push('Other')
        }

        const searchQuery = this.state.search.trim().toLowerCase()
        let installed = [...this.state.apps]
        let available = [...this.state.catalog]
        if (this.state.category !== allLabel) {
            available = available.filter((s) => s.category === this.state.category)
        }
        if (searchQuery) {
            installed = installed.filter((app) =>
                (displayMailchimpAppName(app.Application) || '').toLowerCase().includes(searchQuery)
            )
            available = available.filter((s) => (displayMailchimpAppName(s) || '').toLowerCase().includes(searchQuery))
        }
        const showInstalledSection = !searchQuery || installed.length > 0

        return (
            <div>
                <Row>
                    <Column xs={12} sm={12} md={8} lg={8} className='col-md-offset-2'>
                        <div className='mar-b15' style={{ maxWidth: 250, marginLeft: 'auto' }}>
                            <TextInput
                                placeholder={i18n.t('company:integrations.main.searchPlaceholder')}
                                value={this.state.search}
                                onChange={(e) => this.setState({ search: e.target.value })}
                                iconLeft={
                                    <Icons
                                        icon='magnifier'
                                        style={{ height: 16, width: 16, marginTop: '1px' }}
                                        color='#2B2F41'
                                    />
                                }
                            />
                        </div>
                        {showInstalledSection && (
                            <div>
                                <h4 className='mar-b15'>{i18n.t('company:integrations.main.installedHeader')}</h4>
                                {this.state.apps.length === 0 && (
                                    <div className='mar-b25'>{i18n.t('company:integrations.main.none')}</div>
                                )}
                                {installed.map((app) => (
                                    <InstalledApp key={app.id} app={app} goConfig={this.goConfig} />
                                ))}
                            </div>
                        )}
                        <h4 className={showInstalledSection ? 'mar-t30 mar-b15' : 'mar-b15'}>
                            {i18n.t('company:integrations.main.availableHeader')}
                        </h4>
                        <div className='mar-b15' style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                            {types.map((type) => (
                                <ButtonSimple
                                    key={'integration_' + type}
                                    className='button-simple-fullsize mar-l5 mar-b10'
                                    selected={type === this.state.category}
                                    onClick={() => this.setState({ category: type })}
                                >
                                    {type}
                                </ButtonSimple>
                            ))}
                        </div>
                        {available.length === 0 && (
                            <div className='mar-b25'>{i18n.t('company:integrations.main.noneAvailable')}</div>
                        )}
                        <Row>
                            {available.map((app) => {
                                const { isInstalled, allowMultiple } = catalogInstallState(app, this.state.apps)
                                const goToConfig = isInstalled && !allowMultiple
                                const goToUpgrade = isInstalled && allowMultiple && !canAddDupes
                                const clickable = goToConfig || goToUpgrade || canWrite
                                return (
                                    <Column xs={12} sm={6} md={4} key={app.id}>
                                        <AvailableApp
                                            app={app}
                                            clickable={clickable}
                                            isInstalled={isInstalled}
                                            onInstall={() => this.handleAvailableClick(app)}
                                        />
                                    </Column>
                                )
                            })}
                        </Row>
                    </Column>
                </Row>
            </div>
        )
    }
}

function catalogInstallState(catalogApp, installedApps) {
    const instances = installedApps.filter(
        (installed) => installed.ApplicationId === catalogApp.id || installed.Application?.id === catalogApp.id
    )
    const isInstalled = instances.length > 0
    return {
        instances,
        isInstalled,
        allowMultiple: isInstalled && !!instances[0].UniqueKey
    }
}

function FeaturedChip() {
    return (
        <SquareChip className='square-chip-primary mar-l10'>
            {i18n.t('company:integrations.main.featured')}
        </SquareChip>
    )
}

function isCatalogBetaApp(app) {
    return !!(app && app.options && app.options.beta)
}

function AppLogo({ logoUri }) {
    return (
        <div
            className='avatar'
            style={{
                backgroundImage: 'url(' + logoUri + ')',
                width: 48,
                height: 48,
                backgroundSize: '48px 48px'
            }}
        />
    )
}

function BetaBadge() {
    return <span className='integration-app-beta'>{i18n.t('company:integrations.main.beta')}</span>
}

function InstalledApp({ app, goConfig = () => {} }) {
    const name = app.appSettings?.UniqueName || app.appSettings?.subdomain || app.appSettings?.company_domain
    return (
        <Paper className='quickFlex mar-b25' style={{ padding: 24 }}>
            <div className='mar-r20'>
                <div
                    className='avatar'
                    style={{
                        backgroundImage: 'url(' + app.Application.appLogoUri + ')',
                        width: 48,
                        height: 48,
                        backgroundSize: '48px 48px'
                    }}
                />
            </div>
            <div style={{ flexGrow: 1 }}>
                <div className='text-heavy' style={{ marginBottom: 4 }}>
                    {displayMailchimpAppName(app.Application)}
                    {name ? <SquareChip className='mar-l10'>{name}</SquareChip> : ''}
                    {app.Application.featured ? <FeaturedChip /> : null}
                </div>
                <div className='text-grey'>{app.Application.appDescription}</div>
            </div>
            <div className='quickFlex' style={{ justifyContent: 'flex-end' }}>
                <Button
                    text={i18n.t('company:integrations.main.manage')}
                    iconLeft={<Icons icon='cog' />}
                    onClick={() => goConfig(app)}
                    className='button-sml primary outline'
                />
            </div>
        </Paper>
    )
}

function AvailableApp({ app, clickable, isInstalled, onInstall = () => {} }) {
    const beta = isCatalogBetaApp(app)
    return (
        <Paper
            className={
                'mar-b25 integration-available-tile' +
                (clickable ? ' paper-clickable' : '') +
                (beta ? ' integration-available-tile--beta' : '')
            }
            onClick={clickable ? onInstall : undefined}
            style={{ padding: 24, height: 'calc(100% - 24px)', position: 'relative' }}
        >
            {beta ? <BetaBadge /> : null}
            <div className='mar-b15'>
                <AppLogo logoUri={app.appLogoUri} />
            </div>
            <div className='text-heavy' style={{ marginBottom: 4 }}>
                {displayMailchimpAppName(app)}
                {app.featured ? <FeaturedChip /> : null}
                {isInstalled ? (
                    <SquareChip className='mar-l10'>
                        {i18n.t('company:integrations.add.installed')}
                    </SquareChip>
                ) : null}
            </div>
            <div className='text-grey mar-b10'>{app.appDescription}</div>
            {app.category && (
                <div>
                    <SquareChip className='mar-r10 mar-b5'>{app.category}</SquareChip>
                </div>
            )}
        </Paper>
    )
}
